var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNudgeTwoLineLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_779",
    "data-name": "Group 779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.539,
    height: 74.587,
    viewBox: "0 0 145.539 74.587",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(0 16.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M152.9,246.9V235.7h3.008v8.221h4.468V246.9Z",
    transform: "translate(-152.9 -235.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M193.466,246.9l-.417-1.638h-3.574l-.417,1.638H185.9l3.247-11.2h4.23l3.277,11.2Zm-2.234-8.549-1.013,3.9h2.026Z",
    transform: "translate(-176.07 -235.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M236.451,246.9l-2.472-3.277V246.9H231V235.7h5.719a2.975,2.975,0,0,1,3.008,2.979v1.549a2.982,2.982,0,0,1-2.472,2.949l2.8,3.723Zm.268-8.221h-2.74v2.264h2.77v-2.264Z",
    transform: "translate(-207.736 -235.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M277.825,246.9l-3.217-4.349V246.9H271.6V235.7h3.008v4.349l3.217-4.349h3.634l-4.23,5.6,4.289,5.6Z",
    transform: "translate(-236.243 -235.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M319.955,242.987h-.089V246.8h-3.038v-3.813h-.119a3,3,0,0,1-3.008-3.009V235.6h2.979v4.587h3.277V235.63h2.979v4.379A2.931,2.931,0,0,1,319.955,242.987Z",
    transform: "translate(-265.803 -235.6)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0.089 32.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M176.2,343.436h-6.464v-10.4a37.942,37.942,0,0,0-.119-4.111,5.084,5.084,0,0,0-1.728-3.664,4.4,4.4,0,0,0-2.562-.715c-2.77,0-4.557,1.519-5.332,4.557a25.485,25.485,0,0,0-.3,4.825v9.532H153.2v-23.74h6.494v2.413a12.647,12.647,0,0,1,7.685-3.038,9.339,9.339,0,0,1,6.553,2.472c1.519,1.37,2.264,3.455,2.264,6.2Z",
    transform: "translate(-153.2 -310.551)",
    fill: "#3fb6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M265.389,328.208c-1.072,3.991-2.145,6.643-3.247,7.953-2.74,3.247-6.583,4.23-11.468,2.919-5.362-1.43-8.191-4.468-8.519-9.145-.119-1.549.328-4.14,1.311-7.774l2.562-9.562,6.374,1.7-2.949,11.021a22.2,22.2,0,0,0-.745,3.545,4.483,4.483,0,0,0,1.043,3.426,4.948,4.948,0,0,0,2.413,1.4,4.286,4.286,0,0,0,4.974-1.549,14.1,14.1,0,0,0,1.519-4.14l3.008-11.23,6.315,1.7Z",
    transform: "translate(-215.645 -305.987)",
    fill: "#3fb6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M360.808,323.285h-6.494v-2.5a12.113,12.113,0,0,1-16.919-.655,12.255,12.255,0,0,1-3.4-8.638,12.41,12.41,0,0,1,3.247-8.7,11.49,11.49,0,0,1,8.906-3.813,11.631,11.631,0,0,1,8.162,3.217V290.4h6.494Zm-6.2-11.915a6.783,6.783,0,0,0-1.936-4.945,6.961,6.961,0,0,0-5.183-1.966,6.725,6.725,0,0,0-7,6.94,6.868,6.868,0,0,0,7.03,7.03,6.909,6.909,0,0,0,5.213-2.055A7,7,0,0,0,354.613,311.37Z",
    transform: "translate(-280.145 -290.4)",
    fill: "#3fb6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M463.078,339.97c0,3.991-.894,6.94-2.651,8.847-2.383,2.562-5.957,3.843-10.694,3.843-4.766,0-8.37-1.132-10.783-3.426a10.318,10.318,0,0,1-2.651-4.111h7.149q1.921,2.055,5.987,2.055c3.306,0,5.481-.894,6.464-2.681a9.309,9.309,0,0,0,.655-4.081,11.212,11.212,0,0,1-7.864,2.949,12.053,12.053,0,0,1-9-3.634,12.6,12.6,0,0,1,.417-17.634,11.913,11.913,0,0,1,8.221-3.1,12.236,12.236,0,0,1,8.191,3.217V319.6h6.494V339.97Zm-6.166-8.7a6.441,6.441,0,0,0-1.936-4.8,7.851,7.851,0,0,0-10.187,0,6.294,6.294,0,0,0-2,4.736,6.382,6.382,0,0,0,2,4.825,7.16,7.16,0,0,0,5.153,1.906,6.872,6.872,0,0,0,5.064-1.936A6.24,6.24,0,0,0,456.913,331.272Z",
    transform: "translate(-351.973 -310.481)",
    fill: "#3fb6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M565.5,332.176l-.03,1.132H544.615a6.157,6.157,0,0,0,2.472,4.051,8.307,8.307,0,0,0,4.945,1.46,9.148,9.148,0,0,0,6.255-2.323l5.481,2.353c-2.681,3.485-6.553,5.213-11.706,5.213a14.318,14.318,0,0,1-9.859-3.455,11.368,11.368,0,0,1-3.9-8.906,11.878,11.878,0,0,1,3.783-9,13.294,13.294,0,0,1,9.621-3.6,14.008,14.008,0,0,1,9.949,3.574A12,12,0,0,1,565.5,332.176Zm-6.553-3.6a5.912,5.912,0,0,0-2.592-3.247,7.918,7.918,0,0,0-4.319-1.191,8.132,8.132,0,0,0-4.736,1.37,7.71,7.71,0,0,0-2.383,3.038h14.03Z",
    transform: "translate(-423.59 -310.551)",
    fill: "#3fb6e8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(98.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(2.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M525.449,200.783,523.3,197.3l-1.162.6-.685-1.34s-2.591,2.77-5.57,1.7c.387-1.221.6-2.234.745-2.919a14.557,14.557,0,0,1-3.783.506,9.366,9.366,0,0,1-5.213-1.43,8.634,8.634,0,0,1-3.753-6.077.421.421,0,0,1,.834-.119,7.814,7.814,0,0,0,3.366,5.481c2.2,1.43,5.213,1.668,8.7.715h0l1.162-.268s-1.132-2.264-.447-3.991l1.519,1.013a4.675,4.675,0,0,0,.149-1.1c0-2.949-2.889-4.855-5.957-5.749l.953-1.519a4,4,0,0,0-4.766.655,5.781,5.781,0,0,0-3.753-1.847l.655,1.43c-1.7.089-5.511.6-6.94,3.9h2.2a7.583,7.583,0,0,0-3.366,4.677l1.757-.238c1.4,7.208-4.915,15.549-9.651,18.587l2.86,5.6,2.264-3.634a4.571,4.571,0,0,0,4.5-.6v2.443a8.571,8.571,0,0,0,4.647-3.485v2.443s.328-.149.834-.417a21.548,21.548,0,0,0,9.174-10.485,9.08,9.08,0,0,0,5.362,1.638l-.923-1.549a6.343,6.343,0,0,0,2.145.357A7.532,7.532,0,0,0,525.449,200.783Z",
    transform: "translate(-490.3 -181.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M540.091,208.429a7.814,7.814,0,0,1-3.366-5.481.421.421,0,0,0-.834.119,8.575,8.575,0,0,0,3.753,6.077,9.365,9.365,0,0,0,5.213,1.43,15.758,15.758,0,0,0,3.783-.506c.119-.6.149-.923.149-.923C545.3,210.127,542.3,209.889,540.091,208.429Z",
    transform: "translate(-522.308 -196.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M540.091,208.429a7.814,7.814,0,0,1-3.366-5.481.421.421,0,0,0-.834.119,8.575,8.575,0,0,0,3.753,6.077,9.365,9.365,0,0,0,5.213,1.43,15.758,15.758,0,0,0,3.783-.506c.119-.6.149-.923.149-.923C545.3,210.127,542.3,209.889,540.091,208.429Z",
    transform: "translate(-522.308 -196.336)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M485.079,233.578a1.481,1.481,0,0,1,1.46-1.46,1.6,1.6,0,0,1,1.281.745c.685-2.5,1.966-4.706,4.617-4.825a15.376,15.376,0,0,0,1.043-4.379,8.16,8.16,0,0,0-6.494,1.013l.774,1.013a10.719,10.719,0,0,0-5.183,3.366l.953.447a11.579,11.579,0,0,0-1.43,3.157Z",
    transform: "translate(-482.1 -210.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M558.466,264.519l.923-.745a8.319,8.319,0,0,0-2.562-.774,21.571,21.571,0,0,1-4.528,5.123A11.1,11.1,0,0,1,559.479,272l3.843-5.779-2.979.268A7.545,7.545,0,0,0,558.466,264.519Z",
    transform: "translate(-531.39 -238.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M551.521,210.382a2,2,0,0,1-.715-.119,3.193,3.193,0,0,1-1.787-1.579.426.426,0,1,1,.774-.357,2.276,2.276,0,0,0,1.281,1.132,2.234,2.234,0,0,0,1.757-.357.434.434,0,0,1,.447.745A3.6,3.6,0,0,1,551.521,210.382Z",
    transform: "translate(-529.061 -200.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M569.8,214.324a1.222,1.222,0,0,1-.328-.03,2.4,2.4,0,0,1-1.37-.894.4.4,0,0,1,.119-.6.408.408,0,0,1,.6.119,1.187,1.187,0,0,0,1.757.268.43.43,0,0,1,.477.715A2.322,2.322,0,0,1,569.8,214.324Z",
    transform: "translate(-542.429 -203.452)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(137.526 31.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M622.613,289.7a4.008,4.008,0,1,1-3.991-3.9A3.88,3.88,0,0,1,622.613,289.7Zm-7.03,0a3.034,3.034,0,0,0,3.038,3.128,2.978,2.978,0,0,0,2.979-3.1,3.01,3.01,0,1,0-6.017-.03ZM618,291.727H617.1v-3.9a9.071,9.071,0,0,1,1.489-.119,2.376,2.376,0,0,1,1.37.3,1.128,1.128,0,0,1,.387.864.972.972,0,0,1-.8.894v.06a1.135,1.135,0,0,1,.715.953,2.478,2.478,0,0,0,.3.983h-.983a3.583,3.583,0,0,1-.3-.953c-.06-.417-.3-.626-.8-.626H618Zm.03-2.2h.417c.506,0,.894-.179.894-.566,0-.357-.268-.6-.834-.6a1.771,1.771,0,0,0-.506.06v1.1Z",
    transform: "translate(-614.6 -285.799)",
    fill: "#3fb6e8"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNudgeTwoLineLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nudge-two-line-logo.a0cd9c6b9ac2957c9c96a3d540034e88.svg";